import { schema as schemaTypes } from 'normalizr'

import * as schemas from '../Schemas'

export const SCHEMA_LOOKUP = Object.entries(schemas).reduce((lookup, [name, schema]) => (
  schema instanceof schemaTypes.Entity || schema instanceof schemaTypes.Object
    ? { ...lookup, [schema.key ?? [name[0].toLowerCase(), name.slice(1)].join('')]: schema }
    : lookup
), {})
